import moment from 'moment';

export const getParamForCommercialProductsRequest = (date, dateFormat) => {
  const strDate = moment(date).format(dateFormat || 'YYYY-MM-DD');

  return {
    end_date: `$>=${strDate}`,
    start_date: `$<=${strDate}`,
    _fields: 'rec_name',
    rec_name: '~*',
  };
};
